'use client'

import Link from 'next/link'
import { useEffect, useState } from 'react'

const STORAGE_KEY = 'hubee_cookie_consent_v1'

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY)

      if (!stored) {
        setVisible(true)
      }
    } catch {
      setVisible(true)
    }
  }, [])

  function acceptCookies() {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          value: 'acknowledged',
          acceptedAt: new Date().toISOString(),
        })
      )
    } catch {
      // no-op
    }

    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed inset-x-0 bottom-0 z-[9999] px-4 pb-4 sm:px-6 sm:pb-6">
      <section
        aria-label="Aviso de cookies"
        className="mx-auto flex w-full max-w-5xl flex-col gap-5 rounded-[28px] border border-zinc-200 bg-white p-5 text-zinc-950 shadow-[0_18px_60px_rgba(15,23,42,0.16)] md:flex-row md:items-center md:justify-between md:gap-6 dark:border-white/10 dark:bg-zinc-950 dark:text-white dark:shadow-[0_18px_60px_rgba(0,0,0,0.45)]"
      >
        <div className="min-w-0 flex-1">
          <h2 className="text-base font-black tracking-tight">
            Usamos cookies
          </h2>

          <p className="mt-1 text-sm leading-6 text-zinc-500 dark:text-zinc-400">
            Usamos cookies para mantener tu sesión, mejorar la plataforma y medir el uso de Hubee.
            Al continuar, aceptas nuestra{' '}
            <Link
              href="/cookie-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-zinc-900 underline underline-offset-4 transition hover:text-black dark:text-white"
            >
              Política de Cookies
            </Link>
            .
          </p>
        </div>

        <button
          type="button"
          onClick={acceptCookies}
          className="inline-flex h-11 w-full shrink-0 items-center justify-center rounded-full bg-[#fbbf24] px-6 text-sm font-black text-black transition hover:brightness-95 active:scale-[0.99] md:w-auto"
        >
          Entendido
        </button>
      </section>
    </div>
  )
}